/**
 * 网络数据处理函数
 * zxw 
 * 2025-03-10 
 */

import AssistantBoxHot from './AssistantBoxHot';        //  搜索热点
import AssistantBoxNews from './AssistantBoxNews';      //  搜索新闻
import AssistantBoxSearch from './AssistantBoxSearch';  //  联网搜索

import UserUTACD from '../../pages/reports/UserUTACD';   //  活跃用户
import UserUDATC from '../../pages/reports/UserUDATC';   //  能力类型
import UserUDEBC from '../../pages/reports/UserUDEBC';   //  学历类型
import UserUDSXC from '../../pages/reports/UserUDSXC';   //  男女性别
import UserUTECY from '../../pages/reports/UserUTECY';   //  年度入职
import UserUDBCY from '../../pages/reports/UserUDBCY';   //  年龄区间
import OrgStructureGraph from '../../pages/reports/OrgStructureGraph';   //  组织架构图

import TeiiIntersectionPercent from '../../pages/reports/TeiiIntersectionPercent'    //  teii 路口百分比报表
import TeiiIntersectionITYEC from '../../pages/reports/TeiiIntersectionITYEC'        //  teii 年度建设数量走势

export const renderNetworkData = (d, isMobileDevice, container) => {
    switch (d.type) {
        case 'seal_report_user_search':                                         //  活跃用户seal报表
            return sealGetReport(d.mod, d.data, isMobileDevice, container);     //  seal报表模块和数据
        case 'seal_org_structure_search':                                       //  活跃用户seal报表
            return <OrgStructureGraph data={d.data} />;                         //  seal报表模块和数据
        case 'teii_report_intersection_search':                                 //  teii 路口报表
            return teiiGetReport(d.mod, d.data, isMobileDevice, container);     //  teii 报表模块和数据
        case 'chat_network_hots':
            return <AssistantBoxHot networkDataList={d.data} />     //  搜索热点
        case 'chat_network_news':
            return <AssistantBoxNews networkDataList={d.data} />    //  搜索新闻
        case 'chat_network_search':
            return <AssistantBoxSearch networkDataList={d.data} />  //  联网搜索
        default:
            return '';
    }
}

/**
 * 根据类型获取报表组件
 * @param {*} type  报表类型
 * @param {*} data  报表数据
 * @param {*} isMobileDevice  是否移动端
 * @param {*} container  容器
 */
const sealGetReport = (type, data, isMobileDevice, container = { container }) => {
    switch (type) {
        case 'UTACD':
            return <UserUTACD key={type} data={data} isMobileDevice={isMobileDevice} container={container} />
        case 'UDATC':
            return <UserUDATC key={type} data={data} isMobileDevice={isMobileDevice} container={container} />
        case 'UDEBC':
            return <UserUDEBC key={type} data={data} isMobileDevice={isMobileDevice} container={container} />
        case 'UDSXC':
            return <UserUDSXC key={type} data={data} isMobileDevice={isMobileDevice} container={container} />
        case 'UTECY':
            return <UserUTECY key={type} data={data} isMobileDevice={isMobileDevice} container={container} />
        case 'UDBCY':
            return <UserUDBCY key={type} data={data} isMobileDevice={isMobileDevice} container={container} />
        default:
            return ''
    }
}

/**
 * 根据类型获取报表组件
 * @param {*} type  报表类型
 * @param {*} data  报表数据
 * @param {*} isMobileDevice  是否移动端
 * @param {*} container  容器
 */
const teiiGetReport = (type, data, isMobileDevice, container = { container }) => {
    switch (type) {
        case 'IDHMC':
            return <TeiiIntersectionPercent
                key={type}
                data={data}
                isMobileDevice={isMobileDevice}
                container={container}
                title='路口主机分类占比'
                subtitle='统计路口主机类型所占总数量的百分比。'
            />
        case 'IDINC':
            return <TeiiIntersectionPercent
                key={type}
                data={data}
                isMobileDevice={isMobileDevice}
                container={container}
                title='路口主机联网占比'
                subtitle='统计路口主机联网状态所占总数量的百分比。'
            />
        case 'IDREC':
            return <TeiiIntersectionPercent
                key={type}
                data={data}
                isMobileDevice={isMobileDevice}
                container={container}
                title='路口所属区域占比'
                subtitle='统计路口所属区域所占总数量的百分比。'
            />
        case 'IDSTC':
            return <TeiiIntersectionPercent
                key={type}
                data={data}
                isMobileDevice={isMobileDevice}
                container={container}
                title='路口结构分类占比'
                subtitle='统计路口结构所占总数量的百分比。'
            />
        case 'IDOPC':
            return <TeiiIntersectionPercent
                key={type}
                data={data}
                isMobileDevice={isMobileDevice}
                container={container}
                title='网络厂商分类占比'
                subtitle='统计路口网络厂商所占总数量的百分比。'
            />
        case 'ITYEC':
            return <TeiiIntersectionITYEC
                key={type}
                data={data}
                isMobileDevice={isMobileDevice}
                container={container}
                title='年度建设数量趋势'
                subtitle='展示每年建设数量趋势走势。'
            />
        default:
            return ''
    }
}